module.exports = __webpack_public_path__ + "static/media/personal.9adcc7dd.png";